import { Box, } from "@mui/material";

const CustomTableContainer = ({ children, colors }) => {
  return (
    <Box
      gridColumn="span 9"
      gridRow="span 2"
      alignItems="center"
      justifyContent="center"
      padding={1} // Reduced padding for a tighter layout
      sx={{
        "& .MuiTable-root": {
          border: "none",
          size: "small", // Compact table
        },
        "& .MuiTableCell-root": {
          borderBottom: "none",
          border: "1px solid",
          borderColor: `${colors.primary[400]} !important`,
          padding: "2px", // Tighter padding for cells
          fontSize: "14px", // Reduced font size for compactness

            // 👇 added ellipsis defaults
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",

        },
        "& .name-column--cell": {
          color: colors.greenAccent[300],
          padding: "1px", // Further reduced padding for name column cells
        },
        "& .MuiTableHead-root": {
          borderBottom: "none",
        },
        "& .MuiTableBody-root": {
          overflowY: "auto",
        },
        "& .MuiCheckbox-root": {
          color: `${colors.blueAccent[500]} !important`,
          size: "small", // Reduced checkbox size
          padding: "1px", // Minimal padding around checkboxes
        },
        "& .MuiTableFooter-root": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
          height: "6px", // Slightly reduced footer height
        },
        "& .MuiButton-text": {
          color: `${colors.grey[100]} !important`,
          fontSize: "12px", // Smaller button text for uniformity
        },
      }}
    >

      {children}
    </Box>
  );
};

export default CustomTableContainer;



// import { Box, Table, TableContainer, Paper, alpha } from "@mui/material";

// const CustomTableContainer = ({ children, colors }) => {
//   return (
//     <Box
//       gridColumn="span 9"
//       gridRow="span 2"
//       sx={{
//         "& .MuiTableContainer-root": {
//           borderRadius: 2,
//           border: `1px solid ${alpha(colors.primary[400], 0.3)}`,
//           overflow: "hidden",
//           backgroundColor: alpha(colors.grey[900], 0.1),
//         },
//         "& .MuiTable-root": {
//           borderCollapse: "separate",
//           borderSpacing: 0,
//           minWidth: "100%",
//           tableLayout: "fixed",
//         },
//         "& .MuiTableCell-root": {
//           borderBottom: "none",
//           p: 0.75, // Ultra-compact padding (6px)
//           fontSize: "13px",
//           fontWeight: 500,
//           lineHeight: 1.3,
//           whiteSpace: "nowrap",
//           overflow: "hidden",
//           textOverflow: "ellipsis",
//           color: colors.grey[200],
//           verticalAlign: "middle",
//         },
//         "& .MuiTableCell-head": {
//           backgroundColor: alpha(colors.primary[500], 0.2),
//           fontSize: "12px",
//           fontWeight: 600,
//           textTransform: "uppercase",
//           letterSpacing: "0.5px",
//           borderBottom: `1px solid ${alpha(colors.primary[400], 0.5)}`,
//           position: "sticky",
//           top: 0,
//           zIndex: 10,
//         },
//         "& .name-column--cell": {
//           color: colors.greenAccent[300],
//           fontWeight: 600,
//           maxWidth: "200px",
//         },
//         "& .MuiTableBody-root": {
//           maxHeight: "400px",
//           overflow: "auto",
//         },
//         "& .MuiCheckbox-root": {
//           p: 0.25,
//           color: `${colors.blueAccent[500]} !important`,
//           "& .MuiSvgIcon-root": {
//             fontSize: "16px",
//           },
//         },
//         "& .status-active": {
//           color: colors.greenAccent[400],
//           backgroundColor: alpha(colors.greenAccent[600], 0.1),
//           borderRadius: 1,
//           px: 1,
//           py: 0.25,
//           fontSize: "11px",
//           fontWeight: 600,
//         },
//         "& .status-pending": {
//           color: colors.orangeAccent[400],
//           backgroundColor: alpha(colors.orangeAccent[600], 0.1),
//           borderRadius: 1,
//           px: 1,
//           py: 0.25,
//           fontSize: "11px",
//           fontWeight: 600,
//         },
//         "& .MuiTableRow-root": {
//           "&:hover": {
//             backgroundColor: alpha(colors.primary[400], 0.1),
//           },
//           "&.Mui-selected": {
//             backgroundColor: alpha(colors.primary[400], 0.2),
//           },
//         },
//         "& .MuiTableFooter-root": {
//           backgroundColor: alpha(colors.blueAccent[700], 0.9),
//           borderTop: `1px solid ${colors.primary[300]}`,
//         },
//         "& .MuiButtonBase-root": {
//           p: 0.5,
//           minWidth: "auto",
//           borderRadius: 1,
//         },
//         "& .MuiButton-text": {
//           fontSize: "11px",
//           color: colors.grey[200],
//           textTransform: "none",
//           fontWeight: 500,
//         },

//       }}
//     >
//       <TableContainer component={Paper} elevation={0}>
//         {children}
//       </TableContainer>
//     </Box>
//   );
// };

// export default CustomTableContainer;



